import { hbs } from 'ember-cli-htmlbars';
export default hbs("<span class=\'bold\'>\n  {{@columnDefinition.title}}\n</span>")